<template>
    <rkm-area
        type="fieldset"
        title="Instituição de permanência"
        v-if="showInstituicao"
    >

        <rkm-row v-if="data.model">
            <rkm-col cols="12">
                <rkm-form-input
                    v-model="data.model.instituicao.nome"
                    label="Nome da instituição de permanência"
                    :validations="validations.instituicaoNome"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-radio-group
                    v-model="data.model.instituicao.outrosProfissionais"
                    label="Existem outros profissionais de saúde vinculados à instituição (não inclui profissionais da rede pública de saúde)?"
                    class="pt-0"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-area
                    title="Identificação do responsável técnico da instituição de permanência"
                    no-margin-top
                >
                    <rkm-row>
                        <rkm-col cols="8">
                            <rkm-form-input
                                v-model="data.model.instituicao.nomeResponsavelTecnico"
                                label="Responsável técnico pela instituição"
                                :validations="validations.nomeResponsavelTecnico"
                                uppercase
                            />
                        </rkm-col>
                        <rkm-col cols="4">
                            <rkm-form-input
                                v-model="data.model.instituicao.cnsResponsavelTecnico"
                                label="CNS do responsável"
                                v-mask="mask.cns"
                                :validations="validations.cnsResponsavelTecnico"
                            />
                        </rkm-col>
                        <rkm-col cols="8">
                            <rkm-form-input
                                v-model="data.model.instituicao.cargoResponsavelTecnico"
                                label="Cargo na instituição"
                                :validations="validations.cargoResponsavelTecnico"
                                uppercase
                            />
                        </rkm-col>
                        <rkm-col cols="4">
                            <rkm-form-input
                                v-model="data.model.instituicao.telefoneResponsavelTecnico"
                                label="Telefone de contato"
                                v-mask="numeroMask"
                                :validations="validations.telefoneResponsavelTecnico"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Mixins.
import { mask, object } from '@/mixins'

//Enums
import tipoImovel from '@/enums/atencao-basica/cadastro-domiciliar/tipoImovel'

export default {
    mixins: [ mask, object ],
    computed: {
        validations() {
            return {
                instituicaoNome : {
                    min: 3,
                    max: 100,
                    termo_invalido: this.data.form.termosInvalidos,
                 },
                nomeResponsavelTecnico: {
                    min: 3,
                    max: 70,
                    termo_invalido: this.data.form.termosInvalidos,
                    name: true,
                    required: true,
                },
                cnsResponsavelTecnico: {
                    min_max_without_mask: 15,
                    cns: true,
                },
                cargoResponsavelTecnico : {
                    min: 3,
                    max: 70,
                    termo_invalido: this.data.form.termosInvalidos,
                },
                telefoneResponsavelTecnico : {
                    min_max_without_mask: [10, 11]
                },
            }
        },
        numeroMask() {

            if (this.data.model.instituicao.telefoneResponsavelTecnico === '') {
                return ''
            }

            return this.data.model.instituicao.telefoneResponsavelTecnico
                && this.data.model.instituicao.telefoneResponsavelTecnico.length < 15
                ? this.mask.phone
                : this.mask.cellPhone
        },
        showInstituicao() {

            if(this.data.model && !this.data.model.recusaCadastro) {

                const imovelTipoId = this.data.model.residencia.imovelTipoId
                const tiposImovel = [
                    this.enums.tipoImovel.ABRIGO,
                    this.enums.tipoImovel.INSTITUICAO_DE_LONGA_PERMANENCIA_PARA_IDOSOS,
                    this.enums.tipoImovel.UNIDADE_PRISIONAL,
                    this.enums.tipoImovel.UNIDADE_DE_MEDIDA_SOCIO_EDUCATIVA,
                    this.enums.tipoImovel.DELEGACIA
                ]

                return tiposImovel.includes(imovelTipoId) ? true : false;
            } else {

                return false
            }
        }
    },
    data: () => ({
        enums: {
            tipoImovel
        },
    }),
    props: {
        data: { type: Object, required: false, },
    },
}
</script>